import React from 'react';
import { getSeverity } from './severity-levels';

const BARS = [1, 2, 3, 4] as const;

/**
 * Four bars of rising height, like a signal-strength icon, filled up to the
 * level's rank: critical fills 4, low 1. Drawn in the current text colour,
 * with the unfilled bars faint. Decorative: the level's name says it.
 */
export const SeverityMeter = ({
  severityLevel,
}: {
  severityLevel?: string;
}) => {
  const { rank } = getSeverity(severityLevel);
  return (
    <svg
      aria-hidden
      className="severity--meter"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="currentColor"
      data-testid="severity-meter"
      data-rank={rank}
    >
      {BARS.map((bar) => (
        <rect
          key={bar}
          x={(bar - 1) * 3.5 + 0.5}
          y={14 - (bar * 3 + 2)}
          width="2.5"
          height={bar * 3 + 2}
          rx="0.75"
          opacity={bar <= rank ? 1 : 0.25}
        />
      ))}
    </svg>
  );
};
